import { SavingLocationState } from "../../types";
import { typedAction } from "../helpers";
import { SET_SAVING_LOCATION, RESET_SAVING_LOCATION } from "./actionTypes";

const initialState: SavingLocationState = { directory: "", display: "", webUrl: "", documentLibrary: "", isOneDriveFolder: false, sharePointListId: null };

export const setSavingLocation = (location: SavingLocationState, isOneDriveFolder: boolean = false) => {
    return typedAction(SET_SAVING_LOCATION, { ...location, isOneDriveFolder: isOneDriveFolder });
};

export const resetSavingLocation = () => {
    return typedAction(RESET_SAVING_LOCATION);
}

type SavingLocationAction = ReturnType<typeof setSavingLocation | typeof resetSavingLocation>;

export function savingLocationReducer(
    state = initialState,
    action: SavingLocationAction
): SavingLocationState {
    switch (action.type) {
        case SET_SAVING_LOCATION:
            return action.payload;
        case RESET_SAVING_LOCATION:
            return initialState
        default:
            return state;
    }
}